document.addEventListener('DOMContentLoaded', function () {
    if (typeof PayTomorrow === 'undefined') {
        loadMpeCode();
    }
    var buttons = document.getElementsByClassName("__pt-ppe-button");
    for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function () {
            displayMpe();
        })
    }

    var buttons = document.getElementsByClassName("__pt-ppe-button_faq");
    for (var i = 0; i < buttons.length; i++) {
        buttons[i].addEventListener('click', function () {
            displayMpeFaq();
        })
    }
});
function displayMpeFaq() {
    if (typeof PayTomorrow === 'undefined') {
        return;
    } else {
        PayTomorrow.openFaqIframe();
    }
}

function displayMpe() {
    if (typeof PayTomorrow === 'undefined') {
        return;
    } else {
        PayTomorrow.openMpeIframe();
    }
}

function loadMpeCode() {
    var link = document.createElement('link');
    link.setAttribute('rel', 'stylesheet');
    link.setAttribute('type', 'text/css');
    link.setAttribute('href', 'https://cdn.paytomorrow.com/css/pt-mpe.min.css');
    document.getElementsByTagName('head')[0].appendChild(link);

    var mpeScript = document.createElement('script');
    mpeScript.setAttribute('type', 'text/javascript');
    mpeScript.setAttribute('src', 'https://cdn.paytomorrow.com/js/pt-mpe.min.js');
    document.body.appendChild(mpeScript);

    var interval = setInterval(function () {
        if (typeof PayTomorrow !== 'undefined') {
            PayTomorrow.addPayTomorrowIframe('James Free Jewelers - Online', '20a16d927c03e8ec8318c6e7b368ae3e', 'ECOMMERCE');
            clearInterval(interval);
        }
    }, 2000);

}

function checkForm() {
    event.preventDefault();
    let personalInfo = {
        firstName: document.getElementById("firstName").value,
        lastName: document.getElementById("lastName").value,
        cellPhone: document.getElementById("cellPhone").value,
        email: document.getElementById("email").value
    }
    console.log(personalInfo);

    if(!!personalInfo.firstName && personalInfo.firstName !== '' && !!personalInfo.lastName && personalInfo.lastName !== '' &&
        !!personalInfo.cellPhone && personalInfo.cellPhone !== '' && !!personalInfo.email && personalInfo.email !== ''){
        let publicId = '20a16d927c03e8ec8318c6e7b368ae3e';

        fetch('https://api.paytomorrow.com/api/ecommerce/public/organizations/pre-approval/' + publicId, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(personalInfo)
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            }
            throw new Error('Something went wrong.');
        }).then(function (data) {
            var bt = document.getElementById("successMessage");
            setTimeout(function () {
                bt.style.display = "block";
            }, 600);
            console.log("correct");
        }).catch((error) => {
            var bt = document.getElementById("errorMessage");
            setTimeout(function () {
                bt.style.display = "block";
            }, 600);
            console.log("error");
        });
    } else {
        let bt = document.getElementById("errorMessage");
        setTimeout(function () {
            bt.style.display = "block";
        }, 600);
        console.log("error");
    }
}

function toggleStatus() {
    var element = document.getElementById("successMessage");
    if (element.style.display == 'none') {
        element.style.display = 'block';
    } else {
        element.style.display = 'none';
    }
}

function toggleStatusError() {
    let element = document.getElementById("errorMessage");
    if (element.style.display === 'none') {
        element.style.display = 'block';
    } else {
        element.style.display = 'none';
    }
}